import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { useRecoilState } from 'recoil';
import vhCheck from 'vh-check';
import { CardHeader } from '../../../components/CardHeader';
import { ProductHandle } from '../../../enums/ProductHandle.enum';
import { mobileMenuOpenState } from '../../../recoil/atoms';
import { ImageButton } from '../../../root/components/buttons/ImageButton';
import CartIcon from '../../../root/components/CartIcon';
import { DivButton } from '../../../root/components/DivButton';
import { scrollToTop, assetPathFn } from '../../../util';
import MobileNavMenu from './MobileNavMenu';
import styles from './MobileHeader.module.scss';

// this calculates the offsets necessary for bottom positioning of
// buttons on the iphone. The Library imported here also provides
// the css variable --vh-offset
const vhIphoneAdjustment: {
  isNeeded: boolean;
  value: string | number;
  vh: number;
  windowHeight: number;
  offset: number;
  recompute: () => void;
  unbind: () => void;
} = vhCheck();

export const MobileHeader: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [menuOpen, setMenuOpen] = useRecoilState(mobileMenuOpenState);
  const [isSticky, setSticky] = useState(false); // todo: do we want ab test here?

  if (menuOpen && !isSticky) {
    scrollToTop();
  }

  return (
    <CardHeader>
      <header
        role="banner"
        ref={ref}
        className={classNames(styles.mobileHeader, {
          [styles.hlMobileNavWrapperMenuOpen]: menuOpen,
          [styles.hlMobileNavWrapperSticky]: isSticky,
          [styles.iphoneShift]: vhIphoneAdjustment.isNeeded,
        })}
      >
        <div className={styles.leftControls}>
          <DivButton onClick={() => setMenuOpen(!menuOpen)} aria-expanded={menuOpen ? 'true' : 'false'} label="Open menu">
            <img alt="open menu" style={{ paddingTop: 4 }} src={assetPathFn('menu-open-icon.svg')} />
          </DivButton>
        </div>
        <div className={styles.center}>
          <ImageButton
            dataTrackLabel="Logo"
            dataTrackLocation="header"
            onClick={() => (window.location.href = '/')}
            image={<img className={styles.hlLogoImage} width={300} src={assetPathFn('honeylove-brandmark-black.svg')} alt=" honeylove logo" />}
          />
        </div>
        <div className={styles.rightControls}>
          <CartIcon isMobile={true} />
        </div>
        <MobileNavMenu isOpen={menuOpen} isSticky={isSticky} />
      </header>
    </CardHeader>
  );
};

export interface MenuItem {
  text: string;
  imgUrl?: string;
  activeImgUrl?: string;
  href?: string;
  subItemGroups?: SubItemGroup[];
  dataTrackLabel?: string;
  dataTrackLocation?: string;
  callback?: (e: React.MouseEvent) => void;
}

export interface SubItemGroup {
  group: string;
  subItems: SubItem[];
  href?: string;
}

export interface SubItem {
  text: string;
  handle: ProductHandle;
  selected: boolean;
  description?: string;
  imgUrl?: string;
  activeImgUrl?: string;
  featuredImageUrl?: string;
  featuredTitle?: string;
  featuredSort?: number;
  href?: string;
  dataTrackLabel?: string;
  dataTrackLocation?: string;
  publishedDate?: string;
  callback?: (e: React.MouseEvent) => void;
}

export default MobileHeader;
